import { Col, Row } from 'antd';
import SelectCardMethod, {
  SelectCardMethodProps,
} from 'global/SelectCardMethod';
import { useState } from 'react';
import { OtpChannel } from 'typings/auth';

interface OtpMethodListProps {
  defaultMethod?: OtpChannel;
  data?: Omit<SelectCardMethodProps, 'onClick' | 'checked'>[];
  onSelect?(value: string): void;
}

const OtpMethodList = ({
  defaultMethod = OtpChannel.WhatsApp,
  data,
  onSelect = () => {},
}: OtpMethodListProps) => {
  const [selectedMethod, setSelectedMethod] = useState(defaultMethod);

  const handleMethodClick = (value: OtpChannel) => {
    setSelectedMethod(value);
    onSelect(value);
  };

  return (
    <Row gutter={[0, 12]}>
      {data.map((props) => (
        <Col key={props.value} span={24}>
          <SelectCardMethod
            onClick={handleMethodClick}
            checked={selectedMethod === props.value}
            {...props}
          />
        </Col>
      ))}
    </Row>
  );
};

export default OtpMethodList;
